import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { flattedArrayByKey, parseRangeQuery } from '../../utils/helpers';
import SyntaxHighlighter from 'react-syntax-highlighter';
import ViewSubConditions from './ViewSubConditions';

const Condition = () => {
  const dispatch = useDispatch();
  const { condition_id } = useParams();

  const { condition } = useSelector((state) => state.general);

  const [editNameClicked, setEditNameClicked] = useState(false);
  const [newName, setNewName] = useState('');
  const [editDescClicked, setEditDescClicked] = useState(false);
  const [newDesc, setNewDesc] = useState('');

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      })
    );
  }, []);
  if (condition?._id !== condition_id) {
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: null,
      })
    );
  }
  console.log({ condition });

  return condition?._id && Array.isArray(condition.columns) ? (
    <div className='container mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div
          className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          <h1>Condition Details</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <h4>Name: </h4>{' '}
        {editNameClicked ? (
          <>
            <input
              type='text'
              className='form-control ml-2'
              defaultValue={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
            <button
              className='btn btn-sm btn-outline-dark ml-2 border-0'
              title='Save Name'
              onClick={() => {
                setEditNameClicked(false);
                dispatch(
                  apiAction({
                    reduxField: 'condition',
                    route: `conditions/updateConditionSingleField`,
                    conditionId: condition_id,
                    fieldName: 'name',
                    newValue: newName,
                  })
                );
              }}
            >
              <i className='fas fa-save'></i>
            </button>
            <button
              className='btn btn-sm btn-outline-dark ml-2 border-0'
              title='Cancel'
              onClick={() => {
                setEditNameClicked(false);
              }}
            >
              <i className='fas fa-times'></i>
            </button>
          </>
        ) : (
          <>
            <h4 className='ml-2 text-primary'>{condition.name}</h4>{' '}
            <button
              className='btn btn-sm btn-outline-dark ml-2 border-0'
              title='Edit Name'
              onClick={() => {
                setEditNameClicked(true);
                setNewName(condition.name);
              }}
            >
              <i className='fas fa-edit'></i>
            </button>
          </>
        )}
      </div>
      <>
        <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
          <h4>Description</h4>{' '}
        </div>
        {editDescClicked ? (
          <>
            <div className='row d-flex justify-content-center mb-4 pt-lg-0'>
              <div className='col-md-6' style={{ whiteSpace: 'pre-line' }}>
                <textarea
                  type='text'
                  className='form-control ml-2'
                  defaultValue={condition.description}
                  onChange={(e) => setNewDesc(e.target.value)}
                />
                <div className='row d-flex justify-content-center mb-4'>
                  <button
                    className='btn btn-sm btn-outline-dark ml-2 border-0'
                    title='Save Name'
                    onClick={() => {
                      setEditDescClicked(false);
                      dispatch(
                        apiAction({
                          reduxField: 'condition',
                          route: `conditions/updateConditionSingleField`,
                          conditionId: condition_id,
                          fieldName: 'description',
                          newValue: newDesc,
                        })
                      );
                    }}
                  >
                    <i className='fas fa-save'></i>
                  </button>
                  <button
                    className='btn btn-sm btn-outline-dark ml-2 border-0'
                    title='Cancel'
                    onClick={() => {
                      setEditDescClicked(false);
                    }}
                  >
                    <i className='fas fa-times'></i>
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className='row d-flex justify-content-center mb-4 pt-lg-0'>
              <div className='col-md-6 border p-3' style={{ whiteSpace: 'pre-line' }}>
                {condition.description}
              </div>
              <button
                className='btn btn-sm btn-outline-dark ml-2 border-0'
                title='Edit Name'
                onClick={() => {
                  setEditDescClicked(true);
                  setNewDesc(condition.description);
                }}
              >
                <i className='fas fa-edit'></i>
              </button>
            </div>
          </>
        )}
      </>
      {(() => {
        const columns = flattedArrayByKey(condition.columns, 'table_name');
        return (
          <>
            <div className='row d-flex justify-content-center' data-aos='fade-up' data-aos-delay='200'>
              <div className='col-md-4 d-flex justify-content-center align-items-center border p-2'>
                <span>Number of Tables:</span> <span className='ml-2 text-primary'> {columns.length}</span>
              </div>
              <div className='col-md-4 d-flex justify-content-center align-items-center border p-2'>
                <span>Number of Columns:</span> <span className='ml-2 text-primary'> {condition.columns.length}</span>
              </div>
              <div className='col-md-4 d-flex justify-content-center align-items-center border p-2'>
                <Link className='btn btn-sm btn-outline-dark' to={`/editConditionColumns/${condition._id}`}>
                  Edit Columns and Tables
                </Link>
              </div>
            </div>
            <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
              <h3>Tables Involved</h3>
            </div>
            <div className='row d-flex justify-content-center mt-2' data-aos='fade-up' data-aos-delay='200'>
              {columns.map((column) => {
                return (
                  <div
                    className='col-md-4 d-flex justify-content-center align-items-center border p-2'
                    key={column.table_name}
                  >
                    <Link className='text-primary' to={`/editConditionColumns/${condition._id}`}>
                      <span>{column.table_name}</span>
                    </Link>
                  </div>
                );
              })}
            </div>
            <div className='row d-flex justify-content-center mt-4 border-top'>
              <h1>Range Query</h1>
            </div>
            <div className='row d-flex justify-content-center mt-2'>
              <div className='col-md-12 d-flex justify-content-center flex-wrap'>
                <SyntaxHighlighter language='sql' wrapLines={true}>
                  {condition.rangeQuery?.isManualQuery ? condition.rangeQuery.manualQuery : parseRangeQuery(condition)}
                </SyntaxHighlighter>
              </div>
            </div>
            <div className='row d-flex justify-content-center mt-2'>
              <Link className='btn btn-outline-primary mr-2' to={`/editrangequery/${condition._id}`}>
                Edit Range Query
              </Link>
              <a
                className='btn btn-outline-dark'
                href={`/testrangequery/${condition._id}`}
                target='_blank'
                rel='noreferrer'
              >
                Test Range Query
              </a>
            </div>
            <div className='border-top mt-4'></div>
            <ViewSubConditions condition={condition} />
          </>
        );
      })()}
    </div>
  ) : (
    <Spinner />
  );
};

export default Condition;
